var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurplePlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0526 11.0526H12.9474V6.94737C12.9474 6.42947 12.5179 6 12 6C11.4821 6 11.0526 6.42947 11.0526 6.94737V11.0526H6.94737C6.42947 11.0526 6 11.4821 6 12C6 12.5179 6.42947 12.9474 6.94737 12.9474H11.0526V17.0526C11.0526 17.5705 11.4821 18 12 18C12.5179 18 12.9474 17.5705 12.9474 17.0526V12.9474H17.0526C17.5705 12.9474 18 12.5179 18 12C18 11.4821 17.5705 11.0526 17.0526 11.0526Z",
    fill: "#A020FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurplePlus);
export default __webpack_public_path__ + "static/media/PurplePlus.1c21ee504344366c4cef1b10275924ac.svg";
export { ForwardRef as ReactComponent };